/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import DeliveryHours from '../TrackOrder/DeliveryHours';
import DesktopOrderNumber from './Sections/DesktopOrderNumber';
import DesktopItemDetail from  './DesktopItemDetail';
import DesktopInfos from './Sections/DesktopInfos';
import DesktopBillingDetail from './DesktopBillingDetail';

class DesktopOrderDetails extends React.PureComponent {
    render() {
        const {
            orderDetailById, isGetOrderByIdAndZipcode, uuid, featureFlags, isAuthenticated,
        } = this.props;
        return (
            <div className="width">

                {isGetOrderByIdAndZipcode ? (
                    <DeliveryHours />
                ) : (
                    <DesktopOrderNumber orderDetailById={orderDetailById} />
                )}
                {orderDetailById.map((order) => (
                    <DesktopItemDetail
                        key={order.intOrderNumber}
                        uuid={uuid}
                        ItemDetail={order}
                    />
                ))}
                {isAuthenticated ? (
                    <DesktopBillingDetail orderDetailById={orderDetailById} />
                ) : (
                    ''
                )}

                {!isGetOrderByIdAndZipcode ? (
                    <DesktopInfos featureFlags={featureFlags} />
                ) : (
                    ''
                )}
            </div>
        );
    }
}

DesktopOrderDetails.defaultProps = {
    isGetOrderByIdAndZipcode: '',
    orderDetailById: '',
    uuid: '',
    featureFlags: {},
    isAuthenticated: '',
};

DesktopOrderDetails.propTypes = {
    isGetOrderByIdAndZipcode: PropTypes.bool,
    orderDetailById: PropTypes.array,
    uuid: PropTypes.string,
    featureFlags: PropTypes.object,
    isAuthenticated: PropTypes.bool,
};

export default withRouter(DesktopOrderDetails);
